import React, { useContext } from 'react'
import { OptionContent } from '../style'
import { useFormContext, useWatch } from 'react-hook-form'
import { ClimaOptionsContext } from '..'
import { FormFields } from '~/components/FormFields'
import { Form } from 'semantic-ui-react'
import WarningIcon from '../../WarningIcon'
import ErrorIcon from '../../ErrorIcon'

const FirstStep:React.FC = () => {
  const { control, setValue, clearErrors } = useFormContext()
  const { harvestingMethods, maturityLevels, grainContentTypes } = useContext(ClimaOptionsContext)

  const watchHarvestingMethod = useWatch({ control, name: 'maizeSilage.harvestingMethodId' })
  const watchMaturityLevel = useWatch({ control, name: 'maizeSilage.maturityLevelId' })
  const watchDryMatter = useWatch({ control, name: 'maizeSilage.dryMatter' })

  const isMaturity = Boolean(harvestingMethods.find(harvestingMethod => harvestingMethod.id === watchHarvestingMethod)?.hasMaturityLevelOptions)
  const isGrain = Boolean(maturityLevels.find(maturityLevel => maturityLevel.id === watchMaturityLevel)?.hasGrainContentOptions)

  return <>
    <OptionContent>
      <FormFields.Select
        name='maizeSilage.harvestingMethodId'
        placeholder='Bitte Ernteverfahren auswählen'
        noErrorMessage
        withoutAsterisk
        onChange={(e, data) => {
          setValue('maizeSilage.harvestingMethodId', data.value)
          clearErrors('maizeSilage.harvestingMethodId')
        }}
        control={control}
        label={'Ernteverfahren'}
        options={harvestingMethods?.map(harvestingMethod => ({ value: harvestingMethod.id, text: harvestingMethod.label }))}
      />
      {isMaturity && <FormFields.Select
        name='maizeSilage.maturityLevelId'
        noErrorMessage
        onChange={(e, data) => {
          setValue('maizeSilage.maturityLevelId', data.value)
          clearErrors('maizeSilage.maturityLevelId')
        }}
        control={control}
        placeholder='Bitte Reifegrad auswählen'
        label={'Reifegrad'}
        options={maturityLevels?.map(maturityLevel => ({ value: maturityLevel.id, text: maturityLevel.label }))}
      />}
      {isGrain && <FormFields.Select
        name='maizeSilage.grainContent'
        placeholder='Bitte Körneranteil auswählen'
        noErrorMessage
        onChange={(e, data) => {
          setValue('maizeSilage.grainContent', data.value)
          clearErrors('maizeSilage.grainContent')
        }}
        control={control}
        label={'Körneranteil'}
        options={grainContentTypes?.map(grainContent => ({ value: grainContent.key, text: grainContent.label }))}
      />}
      <Form.Group widths={'equal'}>
        <FormFields.Input
          label={<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <label>{'Wie ist der Trockensubstanz-Gehalt der Maissilage?'}</label>
            {(parseFloat(watchDryMatter) < 25 || parseFloat(watchDryMatter) > 45) && watchDryMatter && <WarningIcon
              control={control}
              name='maizeSilage.dryMatter'
              content={'Der TS-Gehalt liegt außerhalb des Normalbereichs von mindestens 25% und maximal 45%.'}
            />}
            <ErrorIcon
              control={control}
              name='maizeSilage.dryMatter'
            />
          </div>}
          name='maizeSilage.dryMatter'
          noErrorMessage
          onChange={(event) => {
            setValue('maizeSilage.dryMatter', event?.target?.value.replace('% TM', ''))
            clearErrors('maizeSilage.dryMatter')
          }}
          rules={{
            max: {
              value: 99,
              message: 'Der TS-Gehalt liegt außerhalb von mindestens 0% und maximal 99%.'
            }
          }}
          suffix=' % TM'
          placeholder='in % TM'
          control={control}
          typeInput='controled'
        />
        <FormFields.Input
          label={'Wie hoch ist der Frischmasse-Ertrag der Maissilage nach Abzug der Ernteverluste?'}
          name='maizeSilage.freshMassYield'
          noErrorMessage
          suffix=' t FM/ha'
          onChange={(event) => {
            setValue('maizeSilage.freshMassYield', event?.target?.value.replace('t FM/ha', ''))
            clearErrors('maizeSilage.freshMassYield')
          }}
          placeholder='in t FM/ha'
          control={control}
          typeInput='controled'
        />
      </Form.Group>
    </OptionContent>
  </>
}
export default FirstStep